module.exports = __webpack_public_path__ + "img/28.3b584a17.jpg";